import { Component, OnInit } from '@angular/core';
import { ErroresHandler } from 'src/app/base/tools/handler/error.handler';
import { PreguntasFrecuentesService } from '../../services/preguntasFrecuentes.service';

@Component({
  selector: 'app-preguntas-frecuentes',
  templateUrl: './preguntas-frecuentes.component.html',
  styleUrls: ['./preguntas-frecuentes.component.css']
})
export class PreguntasFrecuentesComponent implements OnInit {

  constructor(
    private preguntasService: PreguntasFrecuentesService,
    private erroresHandler: ErroresHandler  
  ) { }

  public preguntas: any[];
  public loading: boolean = true;

  ngOnInit(): void {
    this.preguntasService.getPreguntasFrecuentes().then(data => {
      this.loading = false;
      this.preguntas = data;
    }).catch(e => {
      this.erroresHandler.processError(
          e,
          'none'
      );
    })
  }

}
